import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatisticsComponent } from './statistics.component';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [StatisticsComponent],
  imports: [CommonModule, PipesModule],
  exports: [StatisticsComponent]
})
export class StatisticsModule {}
